import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebaseConfig';

export const logUserActivity = async (userId, userName, action, details = {}) => {
  try {
    await addDoc(collection(db, 'audit_logs'), {
      userId,
      userName,
      action,
      details,
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
      ipAddress: window.location.hostname // Note: This will be the client's hostname
    });
  } catch (error) {
    console.error('Error logging user activity:', error);
  }
}; 